import { Component, OnInit, ViewChild, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { UsuarioService } from 'src/app/service/usuario/usuario.service';
import { PedidosUsuarioResponse} from 'src/app/modal/usuario/pedidos-usuario-response';
import {OrderDetalleService} from 'src/app/service/orderdetalle/order-detalle.service';
import { OrderDetalleResponse } from 'src/app/modal/order-detalle/orderDetalleResponse';
import { OrderPagoService } from 'src/app/service/orderpago/order-pago.service';
import { OrderCabeceraResponse } from 'src/app/modal/order-pago/orderCabeceraResponse';
import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { environment } from 'src/environments/environment';
import { OrderImageResponse } from 'src/app/modal/order-detalle/order-image-response';
import { ProtectedImageService } from 'src/app/service/catalogo/protected-image.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-mis-pedidos',
  templateUrl: './mis-pedidos.component.html',
  styleUrls: ['./mis-pedidos.component.scss']
})
export class MisPedidosComponent implements OnInit, OnDestroy {
   @ViewChild('confirmModal') confirmModal: any;
   @ViewChild('frame') frame: any;
   listaPedidos: PedidosUsuarioResponse = new PedidosUsuarioResponse();
   orderCabeceraResponse:OrderCabeceraResponse =new OrderCabeceraResponse();
   pedidoDetalle:OrderDetalleResponse = new OrderDetalleResponse();
   orderImageResponse:OrderImageResponse = new OrderImageResponse();
   page = 1;
   pageSize = 10;
   productImages: Map<string, SafeUrl> = new Map();
   expandedOrderId: number | null = null;
   orderDetails: Map<number, any> = new Map();
   currentOrderId: number | null = null;
   selectedImageId: string = '';
   selectedProductTitle: string = '';
   showConfirmOverlay: boolean = false;
   downloadingItems: Set<string> = new Set(); // Track de items siendo descargados
   isLoadingPedidos: boolean = true; // Estado de carga de la lista de pedidos

   // Subject para comunicar descargas completadas
   private downloadCompletedSubject = new Subject<string>();
   downloadCompleted$ = this.downloadCompletedSubject.asObservable();

  constructor(private usuarioService:UsuarioService,private utilService:UtilitarioService,
    private orderDetalleService:OrderDetalleService,private orderPagoService:OrderPagoService,
    private protectedImageService: ProtectedImageService,private utilitarioService: UtilitarioService,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private router: Router,
    private cdr: ChangeDetectorRef) { }

  obtenerListaPedidos(){
    this.isLoadingPedidos = true;
    this.listaPedidos = new PedidosUsuarioResponse();
    this.usuarioService.obtenerListaPedidos(this.usuarioService.obtenerIDSessionUsuario()).subscribe({
      next: (data) => {
        this.listaPedidos = data;
        this.isLoadingPedidos = false;
        //console.log(this.listaPedidos);
      },
      error: (error) => {
        console.error('Error al cargar pedidos:', error);
        this.isLoadingPedidos = false;
      }
    });
  }
  imagen(img:String){
   
    return img.replace(/_=4?/,"");
  }
  obtenerDatosPedido(id){
    this.currentOrderId = id; // Guardar el ID actual
    this.utilService.loading = true;
    this.obtenerPedidioXID(id);
    this.pedidoDetalle = new OrderDetalleResponse();
    this.productImages.clear();
    this.orderDetalleService.obtenerOrderDetallePedido(id).subscribe(data=>{
      // Ordenar productos alfabéticamente por título
      if (data.response.list && data.response.list.length > 0) {
        data.response.list.sort((a: any, b: any) => {
          const titleA = a.bookTitle || '';
          const titleB = b.bookTitle || '';
          return titleA.localeCompare(titleB, 'es', { sensitivity: 'base' });
        });
      }

      // Si ya existen detalles en memoria para este pedido, sincronizar estados de descarga
      if (this.orderDetails.has(id)) {
        const cachedDetails = this.orderDetails.get(id);
        // console.log('[MisPedidos] Sincronizando estados de descarga desde cache al modal');

        data.response.list.forEach((product: any) => {
          const cachedProduct = cachedDetails.find((p: any) =>
            p.codeOrderDetailId === product.codeOrderDetailId
          );
          if (cachedProduct) {
            // Usar el estado actualizado del cache
            product.flagDownload = cachedProduct.flagDownload;
            product.dateDownload = cachedProduct.dateDownload;
          }
        });
      }

      this.pedidoDetalle = data;
      // console.log(data);

      // Cargar imágenes protegidas para cada producto
      data.response.list.forEach(pedido => {
        if (pedido.activoId) {
          this.loadProtectedImage(String(pedido.activoId), String(pedido.orderDetailId));
        }
      });

      this.utilService.loading = false;
    })
  }

loadProtectedImage(activoId: string, orderDetailId: number | string) {
  const key = String(orderDetailId);
  this.protectedImageService.getProtectedThumbnail(activoId).subscribe(
    response => {
      if (response.protectedThumbnailUrl) {
        const imageUrl = this.sanitizer.bypassSecurityTrustUrl(response.protectedThumbnailUrl);
        this.productImages.set(key, imageUrl);
      }
    },
    error => console.error('Error al cargar imagen protegida:', error)
  );
}
getProductImage(orderDetailId: number | string): SafeUrl | null {
  return this.productImages.get(String(orderDetailId)) || null;
}
  toggleOrderCollapse(pedidoId: number, event: Event) {
    event.stopPropagation();

    if (this.expandedOrderId === pedidoId) {
      this.expandedOrderId = null;
    } else {
      this.expandedOrderId = pedidoId;

      // Cargar detalles del pedido para mostrar status de descarga
      if (!this.orderDetails.has(pedidoId)) {
        this.loadOrderDetailsForBadges(pedidoId);
      }
    }
  }

  /**
   * Carga los detalles de un pedido específico para mostrar badges de descarga
   * @param orderId ID del pedido
   * @param forceReload Si es true, recarga desde el servidor aunque ya existan en memoria
   */
  private loadOrderDetailsForBadges(orderId: number, forceReload: boolean = false): void {
    // Si ya existen en memoria y no es recarga forzada, no hacer nada
    if (this.orderDetails.has(orderId) && !forceReload) {
      // console.log('[MisPedidos] Detalles ya cargados para pedido:', orderId, '- usando cache');
      return;
    }

    // console.log('[MisPedidos] Cargando detalles del servidor para pedido:', orderId);
    this.orderDetalleService.obtenerOrderDetallePedido(orderId.toString()).subscribe({
      next: (data) => {
        // Ordenar productos alfabéticamente por título
        const sortedList = data.response.list.sort((a: any, b: any) => {
          const titleA = a.bookTitle || '';
          const titleB = b.bookTitle || '';
          return titleA.localeCompare(titleB, 'es', { sensitivity: 'base' });
        });

        // Guardar en el Map para acceso rápido
        this.orderDetails.set(orderId, sortedList);
        // console.log('[MisPedidos] Detalles cargados y guardados en cache para pedido:', orderId);
      },
      error: (error) => {
        console.error('Error al cargar detalles del pedido:', error);
      }
    });
  }

  /**
   * Obtiene el estado de descarga de un producto basado en el objeto del producto
   * @param product Objeto del producto con sus detalles
   * @returns 'downloaded' | 'available' | 'unavailable'
   */
  getProductDownloadStatusByProduct(product: any): 'downloaded' | 'available' | 'unavailable' {
    if (!product) {
      return 'unavailable';
    }

    // Si flagDownload es '1', está descargado
    if (product.flagDownload === '1') {
      return 'downloaded';
    }

    // Si tiene codeOrderDetailId, está disponible para descarga
    if (product.codeOrderDetailId && product.codeOrderDetailId !== '') {
      return 'available';
    }

    return 'unavailable';
  }

  /**
   * Obtiene la fecha de descarga de un producto basado en el objeto del producto
   * @param product Objeto del producto con sus detalles
   * @returns Fecha de descarga o null si no ha sido descargado
   */
  getProductDownloadDateByProduct(product: any): string | null {
    if (!product || product.flagDownload !== '1') {
      return null;
    }

    // Retornar la fecha de descarga
    return product.dateDownload || null;
  }

  /**
   * Actualiza el estado de descarga de un producto después de una descarga exitosa
   * @param codeOrderDetailId ID del detalle del pedido descargado
   */
  private updateProductDownloadStatus(codeOrderDetailId: string): void {
    // console.log('[MisPedidos] Actualizando estado de descarga para:', codeOrderDetailId);

    const currentDate = new Date().toLocaleString('es-PE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });

    // Buscar en todos los detalles de pedidos cargados
    this.orderDetails.forEach((details, orderId) => {
      const product = details.find((p: any) => p.codeOrderDetailId === codeOrderDetailId);
      if (product) {
        // console.log('[MisPedidos] Producto encontrado en orderDetails, actualizando flagDownload a "1"');
        // Actualizar el flag de descarga
        product.flagDownload = '1';
        product.dateDownload = currentDate;
      }
    });

    // Actualizar en pedidoDetalle si existe (para el modal)
    if (this.pedidoDetalle && this.pedidoDetalle.response && this.pedidoDetalle.response.list) {
      const detailProduct = this.pedidoDetalle.response.list.find(
        (p: any) => p.codeOrderDetailId === codeOrderDetailId
      );
      if (detailProduct) {
        // console.log('[MisPedidos] Producto encontrado en pedidoDetalle, actualizando flagDownload a "1"');
        detailProduct.flagDownload = '1';
        detailProduct.dateDownload = currentDate;

        // Forzar detección de cambios para actualizar la vista del modal
        this.cdr.detectChanges();
        // console.log('[MisPedidos] Detección de cambios forzada para actualizar vista del modal');
      }
    }
  }

  isOrderExpanded(pedidoId: number): boolean {
    return this.expandedOrderId === pedidoId;
  }

  mostrarModalConfirmacion(idImg: string, productTitle: string) {
    // Verificar si ya se está descargando este item
    if (this.isDownloading(idImg)) {
      this.utilitarioService.toastrWarning('Esta descarga ya está en proceso. Por favor, espera.');
      return;
    }

    this.selectedImageId = idImg;
    this.selectedProductTitle = productTitle;
    this.showConfirmOverlay = true;
    this.confirmModal.show();
  }

  confirmarDescarga() {
    this.showConfirmOverlay = false;
    this.confirmModal.hide();

    // Marcar como descargando ANTES de iniciar la descarga
    this.downloadingItems.add(this.selectedImageId);

    this.donwloadimagen(this.selectedImageId);
  }

  /**
   * Verifica si un item está siendo descargado actualmente
   */
  isDownloading(idImg: string): boolean {
    return this.downloadingItems.has(idImg);
  }

  cerrarModalConfirmacion() {
    this.showConfirmOverlay = false;
    this.confirmModal.hide();
  }

  donwloadimagen(idImg){
    // NO usar utilService.loading aquí - el botón ya tiene su propio indicador visual
    this.orderDetalleService.obtenerImgDescarga(idImg).subscribe({
      next: (response: any) => {
        // console.log('✅ SUCCESS - Response recibida:', response);
        // console.log('Response status:', response?.status);
        // console.log('Response body:', response?.body);
        // console.log('Response headers:', response?.headers);

        // Verificar que sea una respuesta HTTP válida
        if (!response || !response.body) {
          console.error('❌ Response o body es null');
          this.utilitarioService.toastrError('Error: Respuesta vacía del servidor.');
          // Permitir reintento - remover de downloadingItems
          this.downloadingItems.delete(idImg);
          return;
        }

        // Descarga exitosa - procesar el blob
        const blob = response.body;

        // VALIDACIÓN ADICIONAL: Verificar si el blob es un JSON de error
        // Esto ocurre cuando el servidor devuelve 200 pero con un mensaje de error en JSON
        if (blob.type === 'application/json' || blob.type === 'text/plain') {
          console.warn('⚠️ Blob es JSON o texto - posible mensaje de error del servidor');

          // Leer el contenido del blob para verificar
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const text = reader.result as string;
              // console.log('📄 Contenido del blob:', text);

              // Intentar parsear como JSON
              const jsonData = JSON.parse(text);

              // Verificar si es un mensaje de error
              if (jsonData.response &&
                  (jsonData.response.includes('No se ejecutó') ||
                   jsonData.response.includes('no existe') ||
                   jsonData.response.includes('error') ||
                   jsonData.list && jsonData.list.length === 0)) {
                console.error('❌ Servidor devolvió mensaje de error:', jsonData.response);
                this.utilitarioService.toastrError(jsonData.response || 'El archivo no está disponible en el servidor.');
                // Permitir reintento
                this.downloadingItems.delete(idImg);
                return;
              }
            } catch (e) {
              // Si no es JSON válido, podría ser texto plano con error
              const text = reader.result as string;
              if (text.includes('error') || text.includes('no existe') || text.includes('No se ejecutó')) {
                console.error('❌ Servidor devolvió mensaje de error (texto):', text);
                this.utilitarioService.toastrError('El archivo no está disponible en el servidor.');
                this.downloadingItems.delete(idImg);
                return;
              }
            }
          };
          reader.readAsText(blob);
          return; // Salir aquí y esperar a que el reader termine
        }
        // console.log('Blob recibido, tamaño:', blob.size, 'tipo:', blob.type);

        // Obtener el nombre del archivo desde el header Content-Disposition
        const contentDisposition = response.headers.get('Content-Disposition');
        // console.log('Content-Disposition header:', contentDisposition);

        let fileName = '';

        // Intentar extraer el nombre del archivo del header Content-Disposition
        if (contentDisposition) {
          const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
          if (matches != null && matches[1]) {
            fileName = matches[1].replace(/['"]/g, '');
            // console.log('Nombre de archivo extraído del header:', fileName);
          }
        }

        // Si no se pudo extraer del header, generar nombre basado en el tipo MIME
        if (!fileName) {
          const extension = this.getFileExtensionFromMimeType(blob.type);
          fileName = idImg + extension;
          // console.log('Nombre de archivo generado desde MIME type:', fileName, '(tipo:', blob.type, ')');
        }

        // Crear URL del blob y descargar
        const url = window.URL.createObjectURL(blob);
        const downloadLink = document.createElement('a');
        downloadLink.href = url;
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);

        // console.log('✅ Descarga iniciada:', fileName);

        // Liberar el objeto URL después de un delay
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
        }, 100);

        this.utilitarioService.toastrSuccess(`La descarga inició correctamente.`);

        // IMPORTANTE: NO remover de downloadingItems aquí
        // El botón quedará bloqueado permanentemente para este item
        // ya que la descarga fue exitosa

        // Emitir evento de descarga completada para actualizar badges en tiempo real
        // console.log('[MisPedidos] Emitiendo evento de descarga completada para:', idImg);
        this.downloadCompletedSubject.next(idImg);

        // NO es necesario recargar los datos - la actualización en tiempo real ya lo maneja
        // setTimeout(() => {
        //   if (this.currentOrderId) {
        //     this.obtenerDatosPedido(this.currentOrderId);
        //   }
        // }, 2000);
      },
      error: (error: any) => {
        console.error('❌ ERROR - Error en la descarga');
        console.error('Error status:', error?.status);
        console.error('Error completo:', error);

        // Variable para el mensaje de error
        let errorMessage = '';
        let shouldRemoveFromDownloading = true; // Por defecto, permitir reintento

        // Manejar diferentes códigos de estado HTTP
        switch (error.status) {
          case 404:
            // Archivo no encontrado en el servidor
            // console.log('📁 Error 404 detectado - Archivo no encontrado');
            errorMessage = 'El archivo no existe o no está disponible en el servidor.';
            shouldRemoveFromDownloading = true;
            this.utilitarioService.toastrError(errorMessage);
            break;

          case 409:
            // Conflict - ya descargado
            // console.log('🔒 Error 409 detectado - Archivo ya descargado');
            shouldRemoveFromDownloading = false; // NO permitir reintento

            // Emitir evento de descarga completada para actualizar badges
            // console.log('[MisPedidos] Emitiendo evento para archivo previamente descargado:', idImg);
            this.downloadCompletedSubject.next(idImg);

            // Intentar leer el mensaje del backend
            this.readErrorMessage(error, 'Este archivo ya fue descargado previamente.');
            break;

          case 403:
            // Forbidden - sin permisos
            // console.log('🚫 Error 403 detectado - Sin permisos');
            errorMessage = 'No tienes permisos para descargar este archivo.';
            shouldRemoveFromDownloading = true;
            this.utilitarioService.toastrError(errorMessage);
            break;

          case 500:
          case 502:
          case 503:
            // Errores del servidor
            // console.log('⚠️ Error del servidor detectado:', error.status);
            errorMessage = 'Error del servidor. Por favor, intente nuevamente más tarde.';
            shouldRemoveFromDownloading = true;
            this.utilitarioService.toastrError(errorMessage);
            break;

          case undefined:
          case null:
            // Error de conexión
            console.error('⚠️ Status es undefined - Posible problema con interceptor o CORS');
            errorMessage = 'Error de conexión. Por favor, intente nuevamente.';
            shouldRemoveFromDownloading = true;
            this.utilitarioService.toastrError(errorMessage);
            break;

          default:
            // Otros errores
            // console.log('❌ Error no manejado específicamente:', error.status);
            errorMessage = `Error al descargar el archivo (código ${error.status}). Por favor, intente nuevamente.`;
            shouldRemoveFromDownloading = true;

            // Intentar leer mensaje del servidor
            this.readErrorMessage(error, errorMessage);
            break;
        }

        // Remover de downloadingItems si se permite reintento
        if (shouldRemoveFromDownloading) {
          this.downloadingItems.delete(idImg);
          // console.log('[MisPedidos] Item removido de downloadingItems - reintento permitido');
        } else {
          // console.log('[MisPedidos] Item NO removido de downloadingItems - botón bloqueado permanentemente');
        }
      }
    });
  }
  obtenerPedidioXID(id){
    this.orderCabeceraResponse = new OrderCabeceraResponse();
    this.orderPagoService.obtenerOrderCabecera(id).subscribe(data=>{
      this.orderCabeceraResponse=data;
      // console.log(data);
    })
  }
  ngOnInit(): void {
    this.obtenerListaPedidos();

    // Verificar si hay un parámetro 'p' en la URL para abrir automáticamente el pedido
    this.route.queryParams.subscribe(params => {
      const pedidoId = params['p'];
      if (pedidoId) {
        // Esperar a que se carguen los pedidos antes de abrir el detalle
        setTimeout(() => {
          this.abrirPedidoDesdeUrl(pedidoId);
        }, 500);
      }
    });

    // Suscribirse a eventos de descarga completada para actualizar badges en tiempo real
    this.downloadCompleted$.subscribe(codeOrderDetailId => {
      this.updateProductDownloadStatus(codeOrderDetailId);
    });
  }

  ngOnDestroy(): void {
    // Completar el subject para liberar memoria
    this.downloadCompletedSubject.complete();
  }

  /**
   * Abre automáticamente el detalle de un pedido desde URL
   * Solo puede acceder si el pedido pertenece al usuario autenticado
   */
  abrirPedidoDesdeUrl(pedidoId: string): void {
    // Verificar que el usuario esté autenticado
    if (!this.usuarioService.obtenerIDSessionUsuario()) {
      this.utilitarioService.toastrWarning('Debe iniciar sesión para ver este pedido.');
      this.router.navigate(['/']);
      return;
    }

    // Buscar el pedido en la lista del usuario autenticado
    // Solo puede ver pedidos que estén en SU lista, no de otros usuarios
    const pedido = this.listaPedidos.response.list.find(p => p.number === pedidoId || p.id === pedidoId);

    if (pedido) {
      // El pedido existe y pertenece al usuario autenticado
      // Expandir el pedido en la lista
      this.expandedOrderId = pedido.id;

      // Cargar detalles del pedido para la vista previa (tabla)
      if (!this.orderDetails.has(pedido.id)) {
        this.loadOrderDetailsForBadges(pedido.id);
      }

      // Abrir el modal con los detalles
      if (this.frame) {
        this.frame.show();
        this.obtenerDatosPedido(pedido.id);
      }
    } else {
      // El pedido no existe o no pertenece al usuario autenticado
      this.utilitarioService.toastrWarning('No tiene acceso a este pedido o el pedido no existe.');

      // Limpiar el parámetro de la URL
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {}
      });
    }
  }

  /**
   * Método mejorado para obtener datos del pedido y actualizar la URL
   */
  obtenerDatosPedidoConUrl(id: any, pedidoNumber: string): void {
    // Actualizar la URL sin recargar la página
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { p: pedidoNumber },
      queryParamsHandling: 'merge'
    });

    // Llamar al método original para obtener los datos
    this.obtenerDatosPedido(id);
  }


  // Métodos auxiliares para el nuevo diseño
getStatusClass(status: any): string {
  const s = String(status || '').toLowerCase();
  switch (s) {
    case 'completado':
    case 'entregado':
    case 'finalizado':
      return 'status-completed';
    case 'pendiente':
    case 'en proceso':
      return 'status-pending';
    case 'cancelado':
    case 'rechazado':
      return 'status-cancelled';
    case 'procesando':
    case 'en preparación':
      return 'status-processing';
    default:
      return 'status-pending';
  }
}

getStatusIcon(status: any): string {
  const s = String(status || '').toLowerCase();
  switch (s) {
    case 'completado':
    case 'entregado':
    case 'finalizado':
      return 'fas fa-check-circle';
    case 'pendiente':
      return 'fas fa-clock';
    case 'cancelado':
    case 'rechazado':
      return 'fas fa-times-circle';
    case 'procesando':
    case 'en preparación':
      return 'fas fa-spinner';
    default:
      return 'fas fa-clock';
  }
}

/**
 * Formatea fecha de compra con formato DD/MM/YYYY (4 dígitos de año)
 * Usado para: pedido.date (fecha de compra)
 */
formatDate(dateString: any): string {
  if (!dateString) return 'No disponible';

  try {
    const s = String(dateString).trim();

    // Si viene con formato DD/MM/YYYY (año de 4 dígitos)
    if (s.includes('/')) {
      const parts = s.split(' ');
      const datePart = parts[0]; // "26/10/2025"
      const timePart = parts[1]; // Puede tener hora o no

      const dateParts = datePart.split('/');
      if (dateParts.length === 3) {
        const day = parseInt(dateParts[0], 10);
        const month = parseInt(dateParts[1], 10) - 1;
        const year = parseInt(dateParts[2], 10);

        // Si tiene hora, parsearla
        if (timePart) {
          const timeParts = timePart.split(':');
          const hours = parseInt(timeParts[0] || '0', 10);
          const minutes = parseInt(timeParts[1] || '0', 10);
          const seconds = parseInt(timeParts[2] || '0', 10);

          const parsedDate = new Date(year, month, day, hours, minutes, seconds);

          if (!isNaN(parsedDate.getTime())) {
            const d = String(parsedDate.getDate()).padStart(2, '0');
            const m = String(parsedDate.getMonth() + 1).padStart(2, '0');
            const y = parsedDate.getFullYear();
            const h = String(parsedDate.getHours()).padStart(2, '0');
            const min = String(parsedDate.getMinutes()).padStart(2, '0');
            const sec = String(parsedDate.getSeconds()).padStart(2, '0');
            return `${d}/${m}/${y} ${h}:${min}:${sec}`;
          }
        } else {
          // Solo fecha, sin hora
          const parsedDate = new Date(year, month, day);
          if (!isNaN(parsedDate.getTime())) {
            const d = String(parsedDate.getDate()).padStart(2, '0');
            const m = String(parsedDate.getMonth() + 1).padStart(2, '0');
            const y = parsedDate.getFullYear();
            return `${d}/${m}/${y}`;
          }
        }
      }
    }

    // Si viene en formato estándar (YYYY-MM-DD)
    const date = new Date(s);
    if (!isNaN(date.getTime())) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }

    console.warn('Fecha inválida recibida:', dateString);
    return String(dateString);
  } catch (error) {
    console.error('Error al formatear fecha:', error, 'Fecha recibida:', dateString);
    return String(dateString);
  }
}

/**
 * Formatea fecha de transacción con formato DD/MM/YY HH:mm:ss (2 dígitos de año)
 * Usado para: orderCabeceraResponse.transactiondate (fecha de transacción)
 */
formatTransactionDate(dateString: any): string {
  if (!dateString) return 'No disponible';

  try {
    const s = String(dateString).trim();

    // Si viene con formato DD/MM/YY HH:mm:ss (año de 2 dígitos)
    if (s.includes('/')) {
      const parts = s.split(' ');
      const datePart = parts[0]; // "26/10/25"
      const timePart = parts[1] || '00:00:00'; // "08:39:44"

      const dateParts = datePart.split('/');
      if (dateParts.length === 3) {
        const day = parseInt(dateParts[0], 10);
        const month = parseInt(dateParts[1], 10) - 1;
        let year = parseInt(dateParts[2], 10);

        // Convertir año de 2 dígitos a 4 dígitos
        if (year < 100) {
          // Si es menor a 50, asumimos que es 20XX (2000-2049)
          // Si es mayor o igual a 50, asumimos que es 19XX (1950-1999)
          year = year < 50 ? 2000 + year : 1900 + year;
        }

        const timeParts = timePart.split(':');
        const hours = parseInt(timeParts[0] || '0', 10);
        const minutes = parseInt(timeParts[1] || '0', 10);
        const seconds = parseInt(timeParts[2] || '0', 10);

        const parsedDate = new Date(year, month, day, hours, minutes, seconds);

        if (!isNaN(parsedDate.getTime())) {
          const d = String(parsedDate.getDate()).padStart(2, '0');
          const m = String(parsedDate.getMonth() + 1).padStart(2, '0');
          const y = parsedDate.getFullYear();
          const h = String(parsedDate.getHours()).padStart(2, '0');
          const min = String(parsedDate.getMinutes()).padStart(2, '0');
          const sec = String(parsedDate.getSeconds()).padStart(2, '0');
          return `${d}/${m}/${y} ${h}:${min}:${sec}`;
        }
      }
    }

    console.warn('Fecha de transacción inválida recibida:', dateString);
    return String(dateString);
  } catch (error) {
    console.error('Error al formatear fecha de transacción:', error, 'Fecha recibida:', dateString);
    return String(dateString);
  }
}

  getItemsList(itemsString: string): string[] {
    if (!itemsString) return [];

    // Dividir por '/' y limpiar espacios en blanco, luego ordenar alfabéticamente
    return itemsString.split('/')
      .map(item => item.trim())
      .filter(item => item.length > 0)
      .sort((a, b) => a.localeCompare(b, 'es', { sensitivity: 'base' }));
  }

  /**
   * Obtiene la lista completa de productos con sus detalles para un pedido específico
   * @param orderId ID del pedido
   * @returns Array de productos con sus detalles completos o array vacío si no están cargados
   */
  getOrderProductsWithDetails(orderId: number): any[] {
    const details = this.orderDetails.get(orderId);

    if (!details || details.length === 0) {
      return [];
    }

    // Retornar los detalles ordenados alfabéticamente
    return details.sort((a: any, b: any) => {
      const titleA = a.bookTitle || '';
      const titleB = b.bookTitle || '';
      return titleA.localeCompare(titleB, 'es', { sensitivity: 'base' });
    });
  }

  /**
   * Devuelve el símbolo de moneda según el código de moneda
   * @param currency Código de moneda (PEN, USD, etc.) o símbolo (S/, US$)
   * @returns Símbolo de la moneda
   */
  getCurrencySymbol(currency: any): string {
    if (!currency) return 'S/';

    const curr = String(currency).toUpperCase().trim();

    switch (curr) {
      case 'USD':
      case 'US$':
      case '$':
      case 'DOLARES':
      case 'DOLAR':
        return 'US$';
      case 'PEN':
      case 'S/':
      case 'SOLES':
      case 'SOL':
        return 'S/';
      default:
        // Si ya es un símbolo válido, devolverlo
        if (curr === 'S/' || curr === 'US$') {
          return curr;
        }
        return 'S/'; // Por defecto soles
    }
  }

  /**
   * Convierte abreviaciones de modalidad a nombres completos
   */
  getModalidadFullName(modalidad: string): string {
    if (!modalidad) return '';

    const modalidadUpper = modalidad.trim().toUpperCase();

    switch (modalidadUpper) {
      case 'N':
        return 'Nacional';
      case 'CN':
        return 'Comercial Nacional';
      case 'CI':
        return 'Comercial Internacional';
      case 'I':
        return 'Internacional';
      default:
        // Si ya viene con el nombre completo o es otro valor, devolverlo tal cual
        return modalidad;
    }
  }

  /**
   * Lee y muestra el mensaje de error del backend
   * @param error Objeto de error de HTTP
   * @param defaultMessage Mensaje por defecto si no se puede leer el error del servidor
   */
  private readErrorMessage(error: any, defaultMessage: string): void {
    if (!error.error) {
      this.utilitarioService.toastrError(defaultMessage);
      return;
    }

    // Si error.error es un Blob, convertirlo a texto
    if (error.error instanceof Blob) {
      // console.log('[MisPedidos] Leyendo mensaje de error desde Blob...');
      const reader = new FileReader();

      reader.onload = () => {
        try {
          const errorData = JSON.parse(reader.result as string);
          const mensaje = errorData.response || errorData.message || defaultMessage;
          this.utilitarioService.toastrError(mensaje);
        } catch (e) {
          console.error('[MisPedidos] Error al parsear JSON del Blob:', e);
          this.utilitarioService.toastrError(defaultMessage);
        }
      };

      reader.onerror = () => {
        console.error('[MisPedidos] Error al leer Blob');
        this.utilitarioService.toastrError(defaultMessage);
      };

      reader.readAsText(error.error);
    } else {
      // Si es un objeto JSON directamente
      try {
        const mensaje = error.error.response || error.error.message || defaultMessage;
        this.utilitarioService.toastrError(mensaje);
      } catch (e) {
        console.error('[MisPedidos] Error al acceder al mensaje del error:', e);
        this.utilitarioService.toastrError(defaultMessage);
      }
    }
  }

  /**
   * Obtiene la extensión del archivo basándose en el tipo MIME
   * @param mimeType Tipo MIME del archivo (ej: 'image/jpeg', 'application/pdf')
   * @returns Extensión del archivo con punto (ej: '.jpg', '.pdf')
   */
  private getFileExtensionFromMimeType(mimeType: string): string {
    if (!mimeType) {
      return '.bin'; // Extensión genérica si no hay tipo
    }

    const mimeTypeLower = mimeType.toLowerCase();

    // Mapeo de tipos MIME a extensiones
    const mimeToExtension: { [key: string]: string } = {
      // Imágenes
      'image/jpeg': '.jpg',
      'image/jpg': '.jpg',
      'image/png': '.png',
      'image/gif': '.gif',
      'image/bmp': '.bmp',
      'image/webp': '.webp',
      'image/svg+xml': '.svg',
      'image/tiff': '.tiff',
      'image/x-icon': '.ico',

      // PDFs
      'application/pdf': '.pdf',

      // Documentos
      'application/msword': '.doc',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
      'application/vnd.ms-excel': '.xls',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx',
      'application/vnd.ms-powerpoint': '.ppt',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation': '.pptx',

      // Archivos comprimidos
      'application/zip': '.zip',
      'application/x-rar-compressed': '.rar',
      'application/x-7z-compressed': '.7z',

      // Texto
      'text/plain': '.txt',
      'text/html': '.html',
      'text/css': '.css',
      'text/javascript': '.js',
      'application/json': '.json',
      'application/xml': '.xml',
      'text/csv': '.csv'
    };

    // Buscar extensión en el mapeo
    if (mimeToExtension[mimeTypeLower]) {
      return mimeToExtension[mimeTypeLower];
    }

    // Si no está en el mapeo, intentar extraer del tipo MIME
    // Por ejemplo: "image/jpeg" -> ".jpeg"
    const parts = mimeTypeLower.split('/');
    if (parts.length === 2) {
      const subtype = parts[1].split(';')[0].trim(); // Remover parámetros adicionales
      return '.' + subtype;
    }

    // Si todo falla, usar extensión genérica
    return '.bin';
  }

}
